module.exports = __webpack_public_path__ + "img/dots_bg2.41b4c10c.svg";